




























import {
  Component,
  Vue
} from "@/shared/vuepack";
import {
  CombinedClaimReceiptStatus,
  CombinedClaimReceiptStatusMap,
  HsabExpenseCategory,
  hsabExpenseCategoryMap,
  hsabExpenseOriginatorTypeMap,
} from "@/shared/types";
import moment from "moment";
import HsabExpenseReimbursementStatusPill from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseReimbursementStatusPill.vue";
import { formatCurrency } from "@/shared/currency.js";
import { useUserStore } from "@/shared/store/user";
import { useFamilyStore } from "@/employee/store/family";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import { isNullEmptyOrUndefined } from "@/shared/stringHelper";
import { ExpenseManagementGoLiveDate } from  "@/employee/Utilities/HsabExpenseUtility";

@Component({
  components: {
    HsabExpenseReimbursementStatusPill
  }
})
export default class HsbExpenseCardRowExpenseDetail extends Vue {
  formatCurrency = formatCurrency;
  hsabExpenseOriginatorTypeMap = hsabExpenseOriginatorTypeMap;
  hsabExpenseCategoryMap = hsabExpenseCategoryMap;
  hsabExpenseFormStore = useHsabExpenseFormStore();
  userStore = useUserStore();
  familyStore = useFamilyStore();

  get expense () {
    return this.hsabExpenseFormStore.expense;
  }

  get formattedDateOfService () {
    return moment(this.expense.dateOfService).format("MMM DD, YYYY");
  }

  get formattedSubmittedDate () {
    return moment(this.expense.reimbursement.dateCreated).format("MMM DD, YYYY");
  }

  get formattedOriginator () {
    if (this.expense.originator) {
      return this.hsabExpenseOriginatorTypeMap[this.expense.originator];
    }
    return "Unknown";
  }

  get formattedCategory () {
    if (this.expense.expenseCategory) {
      return this.hsabExpenseCategoryMap[this.expense.expenseCategory];
    }
    return "Unknown";
  }

  get status (): CombinedClaimReceiptStatus {
    return this.expense.reimbursement ?
        this.expense.reimbursement.claimReceiptStatus :
        CombinedClaimReceiptStatus.None;
  }

  get statusDisplayText () {
    return CombinedClaimReceiptStatusMap[this.status];
  }

  get showCategory () {
    return this.hsabExpenseFormStore.hasExpense
        && this.expense.expenseCategory !== undefined
        && this.expense.expenseCategory !== null
        && this.expense.expenseCategory !== HsabExpenseCategory.Unknown;
  }

  get showExpenseType () {
    return this.hsabExpenseFormStore.hasExpense
        && this.expense.expenseType !== undefined
        && this.expense.expenseType !== null
        && this.expense.expenseType !== "";
  }

  get showExpenseSubType () {
    return !isNullEmptyOrUndefined(this.SubTypeDisplay);
  }

  get showAmount () {
    return !isNullEmptyOrUndefined(this.expense)
        && !isNullEmptyOrUndefined(this.expense.amount);
  }

  get showProviderName () {
    return !isNullEmptyOrUndefined(this.expense)
        && !isNullEmptyOrUndefined(this.expense.providerName);
  }

  get showSource () {
    return !isNullEmptyOrUndefined(this.formattedOriginator);
  }

  get showDateOfExpense () {
    return !isNullEmptyOrUndefined(this.expense)
        && !isNullEmptyOrUndefined(this.expense.dateOfService);
  }

  get showSubmittedDate (): boolean {
    if (!isNullEmptyOrUndefined(this.expense)
    && !isNullEmptyOrUndefined(this.expense.reimbursement)
    && !isNullEmptyOrUndefined(this.expense.reimbursement.dateCreated)) {
      const  dateCreated = moment(this.expense.reimbursement.dateCreated);
      const  dateCutoff = moment(ExpenseManagementGoLiveDate);
      return dateCreated > dateCutoff;
    }
    return false;
  }

  get showStatus () {
    return !isNullEmptyOrUndefined(this.statusDisplayText);
  }

  get showRecipient () {
    return !isNullEmptyOrUndefined(this.hsabExpenseFormStore.recipientDisplay);
  }

  get showEobOrClaimNumber () {
    return !isNullEmptyOrUndefined(this.expense)
        && !isNullEmptyOrUndefined(this.expense.externalReferenceId);
  }

  get showMilesTraveled () {
    return ! isNullEmptyOrUndefined(this.expense)
        && ! isNullEmptyOrUndefined(this.expense.numberOfMiles);
  }

  get showMileageReimbursementAmount () {
    return !isNullEmptyOrUndefined(this.expense)
        && !isNullEmptyOrUndefined(this.expense.mileageDollarValue);
  }

  get showComment () {
    return !isNullEmptyOrUndefined(this.expense)
        && !isNullEmptyOrUndefined(this.expense.comment);
  }

  get SubTypeDisplay () {
    if (this.hsabExpenseFormStore.hasExpense
        && this.expense.expenseSubTypeDisplayName !== undefined
        && this.expense.expenseSubTypeDisplayName !== null
        && this.expense.expenseSubTypeDisplayName !== "") {
      return this.expense.expenseSubTypeDisplayName;
    }
    if (this.hsabExpenseFormStore.hasExpense
        && this.expense.expenseSubType !== undefined
        && this.expense.expenseSubType !== null
        && this.expense.expenseSubType !== "") {
      return this.expense.expenseSubType;
    }

    return "";
  }
}
